module.exports = __webpack_public_path__ + "Lato-HeavyItalic.4c67ae6fdd968642a4ad.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-HeavyItalic.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-HeavyItalic.eot
// module chunks = styles